/**
 * Generated by orval v6.17.0 🍺
 * Do not edit manually.
 * Review.Api
 * OpenAPI spec version: 1.0
 */

export type Pillar2OperationStatus = (typeof Pillar2OperationStatus)[keyof typeof Pillar2OperationStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const Pillar2OperationStatus = {
    Success: 'Success',
    Failed: 'Failed',
    Skipped: 'Skipped',
} as const;
